import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Header = () => {
    const activeColor = {
        color: "#42B2B8"
    }
    //Added theme changing option
    const [theme, setTheme] = useState(false);
    const handleTheme = () => {
        theme ? document.querySelector('html').setAttribute('data-theme', 'cupcake') : document.querySelector('html').setAttribute('data-theme', 'retro');
        setTheme(!theme);
    }
    return (
        <header className="shadow-lg bg-neutral">
            <div className="container px-4 m-auto">
                <div className="navbar mb-2  text-neutral-content">
                    <div className=" navbar-start">
                        <span className="text-lg font-bold">
                            <Link to="/">
                                Mihu's Kitchen
                            </Link>

                        </span>
                    </div>
                    <div className="hidden px-2 mx-2 navbar-center lg:flex">
                        <div className="flex items-stretch">
                            {/* Navigation Links  */}
                            <NavLink exact activeStyle={activeColor} to="/" className="btn btn-ghost btn-sm rounded-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                </svg>
                                &nbsp; Home
                            </NavLink>
                            <NavLink activeStyle={activeColor} to="/blogs" className="btn btn-ghost btn-sm rounded-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                                </svg>
                                &nbsp; Blogs
                            </NavLink>
                            <NavLink activeStyle={activeColor} to="/services" className="btn btn-ghost btn-sm rounded-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                                &nbsp; Services
                            </NavLink>
                            <NavLink activeStyle={activeColor} to="/about-us" className="btn btn-ghost btn-sm rounded-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                                </svg>
                                &nbsp; About Us
                            </NavLink>
                        </div>
                    </div>
                    <div className="navbar-end">
                        <button className="btn btn-square btn-ghost tooltip tooltip-bottom " onClick={handleTheme} data-tip="Change Theme">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-6 h-6 stroke-current">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
                            </svg>
                        </button>
                        <button className="btn btn-square btn-ghost">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-6 h-6 stroke-current">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

        </header>
    );
};

export default Header;